
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormInput',
    components: {
      Field,
      ErrorMessage,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      let currentItem: any = props.item;
      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,
      });


      onMounted(() => {

        let item: any = state.item;
        if (!item.hasOwnProperty('value')) {
          item.value = null;
        }
        if (!item.hasOwnProperty('max_lines')) {
          item.max_lines = 1;
        }
        if (!item.hasOwnProperty('min_lines')) {
          item.min_lines = 1;
        }
        if (!item.hasOwnProperty('is_required')) {
          item.is_required = true;
        }
        if (!item.hasOwnProperty('is_editable')) {
          item.is_required = true;
        }

        if (item.type == 'Number') {
          let value = JSON.parse(JSON.stringify(item.value));
          if (value){
            item.value = ConvertToArabicNumbers(value);
          }
        }
      });

      const ConvertToArabicNumbers = (string) => {
        return string.replace(/[\u0660-\u0669]/g, function (c) {
          return c.charCodeAt(0) - 0x0660;
        }).replace(/[\u06f0-\u06f9]/g, function (c) {
          return c.charCodeAt(0) - 0x06f0;
        });
      };

      return {
        ...toRefs(state),
        i18n,
        helpers,
      };
    },
  });
